import { render, staticRenderFns } from "./PlaceTagButtons.vue?vue&type=template&id=33f7ef82&scoped=true"
import script from "./PlaceTagButtons.vue?vue&type=script&lang=js"
export * from "./PlaceTagButtons.vue?vue&type=script&lang=js"
import style0 from "./PlaceTagButtons.vue?vue&type=style&index=0&id=33f7ef82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f7ef82",
  null
  
)

export default component.exports